import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class F1LiveStore extends LocalModel {
    constructor() {
        super('f1Live', {
            namePlural: 'f1Lives',
            namePluralReal: 'f1live',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/f1live/',
                    params: {
                        limit: 100,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/f1live/',
                    params: {},
                },
                save: {
                    url: '/api/f1live/',
                    params: {},
                },
                delete: {
                    url: '/api/f1live/',
                    params: {},
                },
            },
        });
    }

    @observable f1Lives = [];

    @observable f1Live = {};

    @observable newF1Live = {};

    @action
    async loadLiveSession(sessionKey) {
        const response = await util.fetchApi('/api/f1live/', { method: 'GET' }, { sessionKey });
        if (response?.status === 200 && response.data?.length > 0) {
            this.updateKeyValue('f1Live', response.data[0]);
        }
        return response;
    }

    @action
    setLiveData(data) {
        this.updateKeyValue('f1Live', data);
    }
}

const store = new F1LiveStore();
export default store;
